<template>
    <div class="container" style="width: 100%;">
      <div style="width:100px; margin: 0 auto; margin-top: 5px;">
        <img src="../assets/logo.png" width="100" style="background-color: red;"/>      
      </div>
      <div style="text-align: center; font-size:20px; font-weight:bold; margin-top: -30px">Stock Management</div>         
      <div style="display: block; width: 280px; margin: 20px auto;">
        <div style="font-size: 18px; font-weight: bold;">Email</div>      
        <q-input v-model="loginData.email" type="email" outlined :error="loginError" ref="emailInput"/>
        <br>
        <div style="font-size: 18px; font-weight: bold;">Password</div>
        <q-input v-model="loginData.password" type="password" outlined bottom-slots :error-message="loginErrorMessage" :error="loginError" @keyup.enter="login"/>
      </div>
      <q-btn color="primary" label="Login" @click="login" style="display:block; width: 80px; margin: 0 auto;"/>
      <div v-show="loginError" style="background-color: #ffe8e8; border: 2px solid red; width: 300px; overflow: auto; margin: 20px auto; padding: 5px">{{loginErrorMessage}}</div>
    </div>
</template>

<script>

export default {
  name: 'scan_login',
  data () {
    return {
      loginData: {
        email: '',
        password: ''
      },
      loginError: false,
      loginErrorMessage: ''
    }
  },
  methods: {
    reset () {
      this.loginData.email = ''
      this.loginData.password = ''
      this.loginError = false
    },
    async login () {
      if (this.loginData.email && this.loginData.password) {
        try {
          await this.$store.dispatch('auth/login', this.loginData)
          await this.$store.dispatch('cart/init')
          await this.$store.dispatch('filters/fetchProductColours')
          this.reset()
          // eslint-disable-next-line no-undef
          analytics.track('Login')
          this.$router.push('/scan/home')
        } catch (err) {
          if (err.networkError) {
            this.loginErrorMessage = 'Could not contact server'
          } else if (err.graphQLErrors && err.graphQLErrors.length) {
            this.loginErrorMessage = err.graphQLErrors[0].message
          } else {
            this.loginErrorMessage = 'Error'
          }
          this.loginError = true
        }
      } else {
        this.loginError = true
        this.loginErrorMessage = 'Incorrect username or password'
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.$refs.emailInput.focus()
      this.reset()
    })
  }
}
</script>
